import { RitornoPaginazione } from '../../shared/models/RitornoPaginazione';
import { ClassicType } from '../../shared/models/ClassicType';
import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiRestService } from './api-rest.service';
import { ApiRestService as  AdminApiRestService } from '../../Admin/_service/api-rest.service';
import {SerialKey} from "../_Models/serial-key";
import {environment} from "../../../environments/environment";
import {ApiPathsService} from "../../api-paths.service";
import {RmaData} from "../RmaData";
import {map} from "rxjs/operators";
@Injectable({
  providedIn: 'root'
})
export class ProdottiRmaStoreService {
  constructor(private apiRestService: ApiRestService, private adminApiRestService: AdminApiRestService, private apiPaths: ApiPathsService, private rmaData: RmaData){}
  private TYPES = new BehaviorSubject<ClassicType[]>([]);
  private PRODOTTI = new BehaviorSubject<RitornoPaginazione<SerialKey[]>>({total: 0, data: []});
  private EDITABLE = new BehaviorSubject<boolean>(false);
  private SHOW_ADD_FORM = new BehaviorSubject<boolean>(false);
  private SELECTED_PRODOTTO = new BehaviorSubject<SerialKey>(new SerialKey());

  private dataStore: {
    Types: ClassicType[],
    Prodotti: RitornoPaginazione<SerialKey[]>,
    Editable: boolean,
    ShowAddForm: boolean,
    SelectedProdotto: SerialKey,
  } = {
      Types: [],
      Prodotti: {total: 0, data: []},
      Editable: false,
      ShowAddForm: false,
      SelectedProdotto: new SerialKey(),
    }
  readonly $types = this.TYPES.asObservable();
  readonly $editable = this.EDITABLE.asObservable();
  readonly $showAddForm = this.SHOW_ADD_FORM.asObservable();
  readonly $prodotti = this.PRODOTTI.asObservable();
  readonly $selectedProdotto = this.SELECTED_PRODOTTO.asObservable();
  refreshTypes = () => this.TYPES.next(Object.assign({}, this.dataStore).Types);
  refreshprodotti = () => this.PRODOTTI.next(Object.assign({}, this.dataStore).Prodotti);
  refreshEditable = () => this.EDITABLE.next(Object.assign({}, this.dataStore).Editable);
  refreshShowAddForm = () => this.SHOW_ADD_FORM.next(Object.assign({}, this.dataStore).ShowAddForm);
  refreshSelectedProdotto = () => this.SELECTED_PRODOTTO.next(Object.assign({}, this.dataStore).SelectedProdotto);
  getProdottiKeyTypes(){
    var restroute = environment.RmaAddOn.TipoAcquistoSource == "ClientiType" ? '/anagrafica/clienti/types?tipo=1' : '/rma/register/types';
    this.apiPaths.ClassicGet(restroute, { headers: this.rmaData.getRmaHeaders() },this.rmaData.getRmaLink()).subscribe(data => {
      this.dataStore.Types = data;
      this.refreshTypes();
      return this.$types;
    });
  }

  updateSelectedKey(value: SerialKey) {
      this.dataStore.SelectedProdotto = value;
      this.refreshSelectedProdotto();
  }
  updateEditable(value: boolean) {
    this.dataStore.Editable = value;
    this.refreshEditable();
  }
  updateShowAddForm(value: boolean) {
    this.dataStore.ShowAddForm = value;
    this.refreshShowAddForm();
  }
}
